import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
// As UpdateCaptionController::MAX_LENGTH.
const MAX_LENGTH = 200;
/**
 * Sets, changes or removes a photo's caption - see addCaptionButtons.ts.
 * Then the post fetched again, rendered with its new <figcaption>, and the
 * lightbox's list of the discussion's photos (champis-forum's `images`
 * field) told the new caption too.
 */
export default class CaptionModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.caption = Stream(this.attrs.caption);
  }
  className() {
    return 'Modal--small CaptionModal';
  }
  title() {
    return app.translator.trans('champis-captions.forum.modal.title');
  }
  content() {
    const t = function (key, params) {
      if (params === void 0) {
        params = {};
      }
      return app.translator.trans(`champis-captions.forum.modal.${key}`, params);
    };
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "CaptionModal-photo"
    }, m("img", {
      src: this.attrs.imageUrl,
      alt: ""
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "champis-caption"
    }, t('label')), m("input", {
      id: "champis-caption",
      className: "FormControl",
      type: "text",
      maxlength: MAX_LENGTH,
      placeholder: t('placeholder'),
      bidi: this.caption,
      disabled: this.loading
    }), m("div", {
      className: "CaptionModal-count"
    }, t('count', {
      count: this.caption().length,
      max: MAX_LENGTH
    })), m("p", {
      className: "helpText"
    }, t('help'))), m("div", {
      className: "Form-group"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary Button--block",
      loading: this.loading
    }, t('submit_button')), this.attrs.caption && m(Button, {
      className: "Button Button--link Button--block CaptionModal-remove",
      onclick: () => this.save(''),
      disabled: this.loading
    }, t('remove_button'))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.save(this.caption());
  }
  async save(caption) {
    const {
      post,
      uuid,
      url
    } = this.attrs;
    this.loading = true;
    m.redraw();
    try {
      const response = await app.request({
        method: 'PATCH',
        url: `${app.forum.attribute('apiUrl')}/champis-captions/${encodeURIComponent(uuid)}`,
        body: {
          postId: post.id(),
          caption
        },
        errorHandler: this.onerror.bind(this)
      });

      // The lightbox's list (only a discussion's own request has it, the
      // post's leaves it as it is): the new caption put in.
      const discussion = post.discussion();
      const images = discussion ? discussion.attribute('images') : null;
      await app.store.find('posts', post.id());
      if (discussion && images) {
        discussion.pushAttributes({
          images: images.map(image => image.url === url ? {
            ...image,
            caption: response.caption
          } : image)
        });
      }
      this.hide();
    } catch {
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('champis-captions', 'forum/components/CaptionModal', CaptionModal);